import privateInstance from "../privateClient";
import { FetchMarketsOperatedQueryType } from "./types";

export const marketsApi = {
  getMarketsOperated: async () => {
    try {
      const response = await privateInstance.get<
        FetchMarketsOperatedQueryType["Data"]
      >("/rate-manager/list-operating-markets");

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
